import { zaehlerDerEinheit } from '../../../../../lib/immobilien/einheitDetail';
import { NotizenListe } from '../../objekt/panels/NotizenPanel';
import { ZaehlerVerwaltung } from '../../objekt/panels/ZaehlerPanel';
import { useEinheitSeite } from '../EinheitSeitenKontext';
import { kontaktName } from '../../../../../lib/objekte/objektKontakte';

/** Notizen zur Einheit (notizen.einheit_id) – anlegen und löschen wie bisher. */
export function NotizBereich() {
  const { daten, geaendert } = useEinheitSeite();
  return <NotizenListe notizen={daten.notizen} ziel={{ einheit_id: daten.einheit.id }} platzhalter="Notiz zu dieser Einheit …" onGeaendert={() => geaendert('notizen')} />;
}

/** Zähler der Einheit (über die Bezeichnung oder den Mieter zugeordnet) – gleiche Formulare wie beim Objekt. */
export function ZaehlerBereich() {
  const { daten, bezeichnung, aktuell, geaendert } = useEinheitSeite();
  const liste = zaehlerDerEinheit(daten.zaehler, daten.einheit.bezeichnung ?? '', daten.mieter.map(m => m.id));
  return (
    <ZaehlerVerwaltung zaehler={liste} objekt={daten.objekt} onGeaendert={() => geaendert('zaehler')} einheiten={[bezeichnung]}
      vorbelegung={{ einheitBezeichnung: daten.einheit.bezeichnung ?? '', mieter: aktuell ? { id: aktuell.id, label: kontaktName(aktuell), typ: 'mieter' } : null }}
      leerText="Dieser Einheit ist noch kein Zähler zugeordnet. Beim Anlegen sind Einheit und Mieter vorbelegt." />
  );
}
